export const SPRING_TENSION_FAST = 280;
export const SPRING_TENSION_SLOW = 240;
export const SPRING_FRICTION = 30;
export const VERTICAL_SWIPE_DISMISS_THRESHOLD = 140;
export const VERTICAL_SWIPE_DISMISS_VELOCITY = 0.5;
export const VERTICAL_SWIPE_DISMISS_DISTANCE = 50;

export const HORIZONTAL_SWIPE_MIN_THRESHOLD = 80;
export const HORIZONTAL_SWIPE_MAX_THRESHOLD = 180;
export const HORIZONTAL_SWIPE_RATIO = 0.15;
export const HORIZONTAL_SWIPE_VELOCITY = 0.4;
export const HORIZONTAL_SWIPE_DISTANCE = 30;

export const MAX_DRAG_SCALE_REDUCTION = 0.2;
export const DRAG_SCALE_DIVISOR = 800;
export const MAX_BG_OPACITY_REDUCTION = 0.8;
export const BG_OPACITY_DIVISOR = 350;

export const DISMISS_SCALE = 0.8;
export const MAX_ZOOM_SCALE = 5;
export const DOUBLE_CLICK_STEP = 2;
